<template>
  <div v-if="showModal">
    <transition name="modal">
      <div class="">
        <div class="modal-wrapper">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" @click="handleModal">
                  <span aria-hidden="true">&times;</span>
                </button>
                <!-- <h4 class="modal-title">Invoice Preview</h4> -->
              </div>
              <div class="modal-body">
                <!-- modal body -->
                <table>
                  <tr>
                    <td class="arnergyLogo">
                      <img
                        style="width: 150px;"
                        src="https://arnergy.com/wp-content/uploads/2020/07/Arnergy.svg"
                        alt="Arnergy Logo"
                        srcset=""
                      />
                    </td>
                    <td
                      style="display: flex;
justify-content: flex-end;"
                    >
                      <div
                        style="
"
                        class="invoceMeta"
                      >
                        <div class="invoiceMetaData">
                          <b>Invoiced No:</b> {{ `${previewData.CID}-xx-xx` }}
                          <br />
                        </div>
                        <div class="invoiceMetaData">
                          <b>Invoiced To: </b>
                          {{
                            `${previewData.user.firstName} ${previewData.user.lastName}`
                          }}<br />
                        </div>
                        <div class="invoiceMetaData">
                          <b> Date: </b> {{ date }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="office-address" style="font-size: 12px;">
                        <b style="margin-bottom: 20px; color: #1a93ca;">
                          Arnergy Solar</b
                        >
                        <br />
                        <span>
                          22A, Adeleke Adedoyin Str.<br />
                          Victoria Island, Lagos.
                        </span>
                      </p>
                      <p class="office-address" style="font-size: 12px;">
                        <b style="margin-bottom: 20px; color: #1a93ca;"
                          >Customer Details</b
                        >
                        <br />
                        <span
                          style="font-size: 10px; border-bottom: 1px solid #eee; width: 100%;"
                        >
                          <b>Name : </b>
                          {{
                            `${previewData.user.firstName} ${previewData.user.lastName}`
                          }}
                        </span>
                        <br />
                        <span
                          style="font-size: 10px; border-bottom: 1px solid #eee; width: 100%;"
                        >
                          <b>Customer ID : </b> {{ `${previewData.CID}` }}
                        </span>
                        <br />
                        <span
                          style="font-size: 10px; border-bottom: 1px solid #eee; width: 100%;"
                        >
                          <b>Address : </b> {{ `${previewData.user.address}` }}
                        </span>
                        <br />
                        <!-- <span style="font-size: 10px; border-bottom: 1px solid #eee; width: 100%;">
                                                                          <b>Location : </b>  Lagos, Nigeria
                                                                        </span> -->
                        <br />
                      </p>
                    </td>
                    <td
                      style="display: flex;
justify-content: flex-end;"
                    >
                      <div
                        class="invoceMeta"
                        style="width:100%; text-align: right;height: 100pt;"
                      >
                        <span style="">
                          Billing Period:

                          {{
                            `${previewData.period[0]} - ${previewData.period[1]}`
                          }} </span
                        ><br />
                      </div>
                      <!-- Billing Period: {{`${previewData.period[0]} - ${previewData.period[1]}`}} -->
                    </td>
                  </tr>
                </table>

                <table id="invoiceMainTable">
                  <tr id="invoiceMainTable">
                    <th class="sn">SN</th>
                    <th class="description">Description</th>
                    <th class="amount">Amount</th>
                  </tr>

                  <tr class="tr1">
                    <td
                      style="text-align: right; border-right:1px solid #000;border-left:1px solid #000;  margin-bottom: 40px;"
                    >
                      1.1
                    </td>
                    <td class="tdDescription">
                      <b>{{ `${previewData.title}` }}</b
                      ><br />
                      {{ `${previewData.description}` }}
                    </td>
                    <td style="border-left: 1pt solid black !important;">
                      {{
                        `${this.numberWithCommas(
                          parseFloat(previewData.amount).toFixed(2)
                        )}`
                      }}
                    </td>
                  </tr>
                  <tr class="tr100px">
                    <td rowspan="4" class="trTerms"></td>
                    <td
                      style="border-left: 1pt solid black !important;"
                      rowspan="1"
                    >
                      {{
                        `${parseFloat(previewData.orderVat).toFixed(1)}% VAT`
                      }}
                    </td>
                    <td style="" class="tdGrandVatVal">
                      {{
                        `${this.numberWithCommas(
                          parseFloat(previewData.fees.amountVat).toFixed(2)
                        )}`
                      }}
                    </td>
                  </tr>
                  <tr class="tr100px">
                    <td
                      style="border-left: 1pt solid black !important;"
                      class="tdGrandTotal"
                    >
                      Grand Total
                    </td>
                    <td class="tdGrandTotalVal">
                      {{
                        `${this.numberWithCommas(
                          parseFloat(previewData.fees.amountGT).toFixed(2)
                        )}`
                      }}
                    </td>
                  </tr>
                  <tr class="trNoData">
                    <td style="border-left: 1pt solid black !important;"></td>
                  </tr>
                  <tr class="trTerms">
                    <td class="td1Terms">
                      Terms and Conditions: <br /><br />
                      Monthly Subscription: <br />

                      <div>
                        <b>Account Details:</b>
                        <b>ARNERGY SOLAR LIMITED 2.0</b> <br />
                        STANBIC IBTC BANK 0031527436
                      </div>
                    </td>
                    <td class="td1Terms">
                      TIN: 17571205-0001 Payable to Federal Inland Revenue
                      Service
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { Autocomplete, Loading } from "element-ui";
import moment from "moment";

export default {
  name: "preview-subs",
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    previewData: {
      type: Object,
      default: {}
    }
  },
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete
  },
  data: function() {
    return {
      loading: false,
      loadingDel: false,
      loadingEdit: false,
      date: moment().format("YYYY/MM/DD")
    };
  },

  methods: {
    handleModal() {
      this.$emit("showModalUpdate", !this.showModal);
    },
    numberWithCommas(val) {
      if (val != "" && val != null && typeof val != "undefined") {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },
    edit(e) {},
    installationSearch(queryString, cb) {
      let installationList = this.installationList;
      var results = queryString
        ? installationList.filter(installation =>
            this.createFilter(queryString, installation)
          )
        : installationList;
      cb(results);
    },
    noPaymentModelChange(paymentModel) {
      let ctx = this;

      ctx.form.description = ctx.getDescription(paymentModel);
      ctx.form.title = ctx.getTitle(paymentModel);
    },
    createFilter(queryString, installation) {
      return (
        `${installation.name} - ${installation.CID}`
          .toLowerCase()
          .indexOf(queryString.toLowerCase()) > -1
      );
    },
    contactSelected(installation) {
      // console.log({ installation });

      let ctx = this;
      let { form } = ctx;
      let { deviceRequest, user, locations } = installation;
      // console.log({ location: deviceRequest });

      let paymentModel = deviceRequest.paymentModel;
      if (paymentModel == "LO" || paymentModel == "ES") {
        form.paymentModel = paymentModel;
        form.description = ctx.getDescription(paymentModel);
        form.title = ctx.getTitle(paymentModel);
        form.userId = user.id;
        form.CID = installation.CID;
        form.installationId = installation.id;
        // User
        form.user.firstName = user.firstName;
        form.user.lastName = user.lastName;
        form.user.email = user.email; //
        form.user.ccEmails = user.ccEmails; //
        form.user.id = user.id; //
        // Location
        form.location =
          typeof locations == "undefined" ? "" : locations.streetRoute;

        ctx.form = form;
      } else {
        ctx.form = {
          amount: "",
          title: "",
          description: "",
          orderVat: "7.5",
          installation: null,
          paymentModel: "",
          ccEmails: "",
          user: {
            address: ""
          },
          filterDate: [],
          location: ""
        };
        alert("Only ES and LO are Allowed");
      }
    },
    getDescription(paymentModel) {
      let desc = "";
      let md = paymentModel != null ? paymentModel.toUpperCase() : "";
      switch (md) {
        case "ES":
          desc =
            "Design, Installation, Commissioning and Managed Service of a 4.5kWp Solar PV System with 10.8kWh Lithium-ion battery Storage";
          break;
        case "OS":
          desc = "OUTRIGHT SALE";
          break;
        case "LO":
          desc =
            "Design, Installation, Commissioning and Managed Service of a 4.5kWp Solar PV System with 10.8kWh Lithium-ion battery Storage";
          break;
        default:
          desc = "MONTHLY SUBSCRIPTION";
          break;
      }
      return desc;
    },
    getTitle(paymentModel) {
      let title = "";
      let md = paymentModel != null ? paymentModel.toUpperCase() : "";
      switch (md) {
        case "ES":
          title = "ARNERGY 5000 - ENERGY AS A SERVICE SUBSCRIPTION";
          break;
        case "OS":
          desc = "OUTRIGHT SALE";
          break;
        case "LO":
          title = "ARNERGY 5000 - LEASE TO OWN REPAYMENT";
          break;
        default:
          desc = "MONTHLY SUBSCRIPTION";
          break;
      }
      return title;
    }
  },
  created() {
    let ctx = this;
    // alert(ctx.previewOffCanvas)
  }
};
</script>
<style scoped>
@media only screen and (max-width: 620px) {
  table[class="body"] h1 {
    font-size: 28px !important;
    margin-bottom: 10px !important;
  }
  table[class="body"] p,
  table[class="body"] ul,
  table[class="body"] ol,
  table[class="body"] td,
  table[class="body"] span,
  table[class="body"] a {
    font-size: 16px !important;
  }
  table[class="body"] .wrapper,
  table[class="body"] .article {
    padding: 10px !important;
  }
  table[class="body"] .content {
    padding: 0 !important;
  }
  table[class="body"] .container {
    padding: 0 !important;
    width: 100% !important;
  }
  table[class="body"] .main {
    border-left-width: 0 !important;
    border-radius: 0 !important;
    border-right-width: 0 !important;
  }
  table[class="body"] .btn table {
    width: 100% !important;
  }
  table[class="body"] .btn a {
    width: 100% !important;
  }
  table[class="body"] .img-responsive {
    height: auto !important;
    max-width: 100% !important;
    width: auto !important;
  }
}

/* -------------------------------------
        PRESERVE THESE STYLES IN THE HEAD
    ------------------------------------- */
@media all {
  .ExternalClass {
    width: 100%;
  }
  .ExternalClass,
  .ExternalClass p,
  .ExternalClass span,
  .ExternalClass font,
  .ExternalClass td,
  .ExternalClass div {
    line-height: 100%;
  }
  .apple-link a {
    color: inherit !important;
    font-family: inherit !important;
    font-size: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
    text-decoration: none !important;
  }
  #MessageViewBody a {
    color: inherit;
    text-decoration: none;
    font-size: inherit;
    font-family: inherit;
    font-weight: inherit;
    line-height: inherit;
  }
  .btn-primary table td:hover {
    background-color: #34495e !important;
  }
  .btn-primary a:hover {
    background-color: #34495e !important;
    border-color: #34495e !important;
  }
}
table tr td {
  text-align: left;
}
.arnergyLogo {
  vertical-align: baseline;
}
.invoiceMeta {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 70%;
}

.invoiceMetaData {
  justify-content: flex-end;
  display: flex;
}
.invoiceMetaData b {
  margin-right: 5pt;
  text-align: left;
}

#invoiceMainTable th {
  padding-top: 12px;
  padding-bottom: 12px;
  background-color: #1a93c9 !important;
  color: white !important;
  border: black solid 1pt !important;
}

.sn {
  width: 8%;
  border: black solid 1pt !important;
  background-color: #1a93c9 !important;
  color: white !important;
}

.description {
  width: 73%;
  border: black solid 1pt !important;
  background-color: #1a93c9 !important;
  color: white !important;
}

.amount {
  width: 19%;
  border: black solid 1pt !important;
  background-color: #1a93c9 !important;
  color: white !important;
}
.tr1 {
  border-left: 1pt black solid;
  border-right: 1pt black solid;
}
.tdGrandTotal {
  border-left: 1pt black solid !important;
  border-bottom: 1pt black solid !important;
}
.tdGrandTotalVal {
  border-right: 1pt black solid !important;
  border-bottom: 1pt black solid !important;
  border-left: 1pt solid black !important;
}
.tdGrandVatVal {
  border: 1pt black solid !important;
}
.tdDescription {
  border: 1pt solid black !important;
}

.trNoData {
  border-left: 1pt solid black !important;
  border-right: 1pt solid black !important;
}

.trTerms {
  border: 1pt solid black !important;
}

.td1Terms {
  border-bottom: 1pt solid black !important;
  border-top: 1pt solid black !important;
  border-left: 1pt solid black !important;
}

.tr100px {
  height: 70px;
}
.invoceMeta {
  word-break: break-all;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/subsmanager/preview.vue